import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { SubTasksBaseDataProvider } from '../dataProvider/SubTasksBaseDataProvider';
import { SubTasksDataProviderFactory } from '../factory/SubTasksDataProviderFactory';
import { SubTaskItem } from '../types';

export class SubTasksRepository extends BaseWebComponentRepository {
  public dataProviderFactory: SubTasksDataProviderFactory;
  public dataProvider: SubTasksBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new SubTasksDataProviderFactory(),
    });
  }
  public async getDataForView() {
    return this.dataProvider.getDataForView();
  }

  public async createTasks(records: Array<SubTaskItem>, taskType, taskName) {
    return this.dataProvider.createTasks(records, taskType, taskName);
  }

}
